import { connect } from 'react-redux';
import { EMPTY_ARRAY, IApplicationState } from '../../../../../../../../types/types';
import { ICardChecklistsHOCProps } from './types';
import { onDidMount } from './events/onDidMount';
import { ICardChecklist, ICardChecklistsEvents, ICardChecklistsFields } from '../../components/CardChecklists/types';
import { onToggle } from './events/onToggle';
import { CardChecklists } from '../../components/CardChecklists/CardChecklists';
import {
    getAuthUserChecklistOrderMode
} from '../../../../../../../../store/model/authUser/selectors/getAuthUserChecklistOrderMode';
import {
    getAuthUserIsHideDoneChecklistItems
} from '../../../../../../../../store/model/authUser/selectors/getAuthUserIsHideDoneChecklistItems';
import { getAuthUser } from '../../../../../../../../store/model/authUser/selectors/getAuthUser';
import { getBoardUsers } from '../../../../../../../../store/model/selectors/getBoardUsers';
import { getBoardIdByCardId } from '../../../../../../../../store/model/selectors/getBoardIdByCardId';
import { getBoardWorkHoursInDay } from '../../../../../../../../store/model/selectors/getBoardWorkHoursInDay';
import { getCheckListsMemo } from './helpers/getShowCheckLists';
import {
    getCardPinnedSectionsCreateSelector
} from '../../../../../../../../store/model/selectors/getCardPinnedSections';
import { isEqual } from 'underscore';

// const analyze = new Analyze('CardAttachmentHOC');
// average: 0.014 ms, calls: 800, total: 10.900 ms (reselects)

const mapStateToProps = () => {
    const getCheckLists = getCheckListsMemo();
    const getCardPinnedSections = getCardPinnedSectionsCreateSelector();

    interface ICaheProps extends ICardChecklistsFields{};
    let cache: ICaheProps = null;
    const getCache = (
        value: ICaheProps
    ): ICaheProps => {
        if (isEqual(value, cache)) return cache;
        cache = value; return value;
    };

    return (
        state: IApplicationState,
        props: ICardChecklistsHOCProps
    ): ICardChecklistsFields => {
        // analyze.start();
        const { cardId, isQuickLook, checklists } = props;
        const authUser = getAuthUser(state); //реселект - все ок
        const checklistOrderMode = getAuthUserChecklistOrderMode(state) // без реселекта - все ок
        const isHideDoneChecklistItems = getAuthUserIsHideDoneChecklistItems(state); // без реселекта - все ок
        const pinnedChecklistsIds= getCardPinnedSections(state, cardId).checklists || EMPTY_ARRAY;
        const ids = isQuickLook
            ? [...Object.keys(checklists).map(id => Number(id)).filter(id => !pinnedChecklistsIds.includes(id))]
            : pinnedChecklistsIds; //реселект - все ок
        const showChecklists: ICardChecklist[] = getCheckLists(checklists, ids, isHideDoneChecklistItems, checklistOrderMode, pinnedChecklistsIds); //memo - все ок

        const cardChecklists = getCache({
            authUserPermissionId: authUser.permissionId,
            checklists: showChecklists.length ? showChecklists : null,
            boardUsers: getBoardUsers(state, getBoardIdByCardId(state, cardId)), //реселект - все ок
            workHoursInDay: getBoardWorkHoursInDay(state, getBoardIdByCardId(state, cardId)), // без реселекта - все ок
            cardId,
        });
        // analyze.finish();
        return cardChecklists;
    };
};

const mapDispatchToProps = (
    dispatch: any,
    { cardId, isQuickLook, onHeightChange, onToggleLoadingImg, isClone }: ICardChecklistsHOCProps
): ICardChecklistsEvents => {
    return {
        onDidMount: () => dispatch(onDidMount(cardId, isQuickLook, isClone)),
        onToggle: (checklistId, itemId) => dispatch(onToggle(cardId, checklistId, itemId)),
        onHeightChange,
        onToggleLoadingImg,
    };
};

export const CardChecklistsHOC = connect(
    mapStateToProps,
    mapDispatchToProps,
)(CardChecklists);

CardChecklistsHOC.displayName = 'CardChecklistsHOC';
